import { html } from 'fxjs/es';
import { UtilObjS } from '../../../../../Util/Object/S/Function/module/UtilObjS.js';
import { mobileHTML } from './header_mo.js';
import { pcTabletHTML } from './header_pc.js';

export const hamMenuLoginHTML = (login_user) => {
  const tt_logout = TT('omp_layout::left::sub_07');
  const tt_my_page = TT('omp_layout::left::sub_06');

  if (login_user) {
    return html` <div class="mp-header-ham__item">
        <a href="/${TT.lang}/logout" class="mp-header-mo__item mp-header-mo__logout">${tt_logout}</a>
      </div>
      <div class="mp-header-ham__item login_view">
        <a href="/${TT.lang}/my-page">${tt_my_page}</a>
      </div>`;
  } else {
    return html`
      <div class="mp-header-ham__item">
        <a href="/${TT.lang}/signup" class="mp-header-mo__item mp-header-mo__sign-up ham_btn_signup"
          >${T('Sign up')}</a
        >
      </div>
      <div class="mp-header-ham__item">
        <a href="/${TT.lang}/login" class="mp-header-mo__item mp-header-mo__sign-in ham_btn_login"
          >${T('Sign in')}</a
        >
      </div>
    `;
  }
};

/**
 * @param {object} [param = {}]
 * @param {string} param.type
 * @param {object} param.locals
 * @param {string} param.title
 * @param {CateList[] | null} param.sub_menus
 * @param {boolean} [param.is_back]
 * @param {HeaderSearchParam} [locals.search = {}]
 * @param {object[] | null} param.sub_interactive_items
 */
export const headerHTML = ({
  type,
  locals,
  title,
  menu_title,
  sub_menus,
  is_back = true,
  sub_menu_all,
  sub_menu_items,
  sub_interactive_items,
} = {}) => {
  const { header_banner, policies, login_user, counts, search = {} } = locals;
  const wish_bp_count = counts.wish + counts.wish_products;
  const header_banner_type = header_banner ? 'header_banner' : '';
  const txt_all = TT('omp_layout::sub_menu_all');

  if (locals.ua.is_mobile && !locals.ua.is_tablet) {
    return mobileHTML({
      wish_count: wish_bp_count,
      cart_count: counts.cart,
      search_value: search.value,
      sub_menu_all,
      sub_menus,
      sub_menu_items,
      sub_interactive_items,
      policies,
      login_user,
      header_banner,
      type,
      is_back,
      title,
      menu_title,
      header_banner_type,
      ham_menus: UtilObjS.deepClone(locals.cate_lists || []),
      mp_navigations: locals.mp_navigations || [],
    });
  } else {
    return pcTabletHTML({
      type,
      header_banner,
      wish_count: wish_bp_count,
      cart_count: counts.cart,
      search_value: search.value,
      sub_menu_all: {
        active: false,
        text: txt_all,
        link: {},
      },
      sub_menus,
      header_banner_type,
      sub_interactive_items,
    });
  }
};
